import React from "react";
import type { TFunction } from "i18next";
import U2000InputCalendarCustom from "../../../../u2000Core/components/formControls/input/U2000InputCalendarCustom";
import type { U2000FormStateHandlers } from "../../../../u2000Core/reducer/formReducer/U2000FormStateHandlers";
import { NS } from "../../../U3104";
import type { U3104AccountingYearFormRow } from "../../../U3104Service";

interface U3104AccountingPeriodsSectionProps {
  formStateHandlers: U2000FormStateHandlers<U3104AccountingYearFormRow>;
  t: TFunction;
}

const U3104AccountingPeriodsSection: React.FC<U3104AccountingPeriodsSectionProps> = ({ formStateHandlers, t }) => {
  const rows = formStateHandlers.getData()?.accountingPeriods ?? [];

  return (
    <div className="space-y-4">
      <h3 className="text-base font-semibold text-gray-900">{t("lblSectionPeriods", { ns: NS })}</h3>
      <div className="overflow-x-auto rounded-lg border border-gray-200">
        <table className="min-w-full divide-y divide-gray-200 text-sm">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-3 py-2 text-left font-medium text-gray-700">{t("lblPeriodNumber", { ns: NS })}</th>
              <th className="px-3 py-2 text-left font-medium text-gray-700">{t("lblPeriodStart", { ns: NS })}</th>
              <th className="px-3 py-2 text-left font-medium text-gray-700">{t("lblPeriodEnd", { ns: NS })}</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 bg-white">
            {rows.map((p, i) => (
              <tr key={p.periodNumber}>
                <td className="whitespace-nowrap px-3 py-2 align-middle text-gray-800">{p.periodNumber}</td>
                <td className="min-w-[200px] px-3 py-2 align-middle">
                  <div className="flex min-w-0 flex-col gap-1">
                    <U2000InputCalendarCustom
                      popupZIndex={9999}
                      formStateHandlers={formStateHandlers as never}
                      fieldName={`accountingPeriods.${i}.startAt`}
                      label=""
                      dateFormat="yyyy-MM-dd"
                    />
                  </div>
                </td>
                <td className="min-w-[200px] px-3 py-2 align-middle">
                  <div className="flex min-w-0 flex-col gap-1">
                    <U2000InputCalendarCustom
                      popupZIndex={9999}
                      formStateHandlers={formStateHandlers as never}
                      fieldName={`accountingPeriods.${i}.endAt`}
                      label=""
                      dateFormat="yyyy-MM-dd"
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default U3104AccountingPeriodsSection;
